import React, { FunctionComponent } from "react";
import { Section } from "../../../core/layout/view/elements/section.elements";

const MainPanel: FunctionComponent = ({ children }): JSX.Element => {
  return <Section>{children}</Section>;
};

export default MainPanel;
